import styled from "styled-components";

// Constants
import colors from "../../../../css/colors";

// Components
import { Button as ButtonBase } from "antd";

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  z-index: 1;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.WHITE};
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 426px) {
    justify-content: center;
  }

  @media screen and (max-width: 767px) {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px;

  @media screen and (max-width: 767px) {
    &:last-child {
      padding: 0 24px 16px;
    }
  }
`;

interface HeaderTextProps {
  margin?: string;
}

export const HeaderText = styled.h1<HeaderTextProps>`
  margin: ${(props) => (props.margin ? props.margin : 0)};
  font-weight: 600;
  font-size: 20px;
`;

export const ProductTypeTag = styled.div`
  font-size: 12px;
  background: none;
  padding: 4px 6px;
  text-align: center;
  border-radius: 4px;
  background: ${colors.BLUE_EXTRA_LIGHT};
  color: ${colors.BLUE};
  border: 1px solid ${colors.BLUE};
`;

export const DiscardButton = styled(ButtonBase)`
  border-radius: 6px;
`;

export const CreateProductButton = styled(ButtonBase)`
  margin: 0 0 0 16px;
  border-radius: 6px;
`;
